// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 571 ? "b637e9a5" : chunkId) + "." + {"80":"52b4bdb3aae68e24","464":"24f1ee9346fe9956","571":"7090d2ce543cd2e7","913":"c595f9677184ea88"}[chunkId] + ".js";
};